import { Truck, ShieldCheck, Palette, Hand } from "lucide-react";

const values = [
  { icon: Palette, label: "Design tunisien unique", emoji: "🎨" },
  { icon: ShieldCheck, label: "Vinyle premium durable", emoji: "✨" },
  { icon: Truck, label: "Livraison gratuite dès 59$", emoji: "🚚" },
  { icon: Hand, label: "Fait main avec soin", emoji: "🤲" },
];

export const ValuesBar = () => {
  return (
    <section className="border-y border-primary/10 bg-gradient-to-r from-cream via-sand-light to-cream">
      <div className="container mx-auto px-4 py-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {values.map((v) => (
            <div
              key={v.label}
              className="group flex items-center gap-3 justify-center rounded-2xl border border-primary/10 bg-background/60 backdrop-blur-sm px-4 py-4 hover:border-primary/30 hover:bg-primary/5 hover:shadow-warm transition-all duration-300 cursor-default hover:-translate-y-0.5"
            >
              <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <v.icon className="w-5 h-5 text-primary shrink-0" />
              </div>
              <span className="font-body text-sm text-muted-foreground group-hover:text-foreground transition-colors leading-tight">{v.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
